import React, {Fragment} from 'react'


import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Button,
  Breadcrumbs,
  Head,
  Card,
  Input,
  Pill,
  RadioGroup,
  Icon,
  Tag,
  FormFooter,
  Notification
} from "xsolla-uikit";

export default function PAaccountingDocuments() {
  return (
    <div style={{minHeight: 800}}>
      <Notification
        title={
          <Fragment>
            Licensing agreement is not signed
          </Fragment>
        }
        status="warning"
        // size="sm"
      >
        <a>Sign</a>
      </Notification>
    </div>
  )
}
